module.exports = __webpack_public_path__ + "img/import_shadow.0880e71.png";